import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { inventoryApi, type InventoryListParams } from '../api/inventory-api';

import { inventoryKeys } from './inventory-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function inventoryLevelsQueryOptions(storeId: string, params: InventoryListParams) {
  return queryOptions({
    queryKey: inventoryKeys.levelList(storeId, params),
    queryFn: () => inventoryApi.levels(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useInventoryLevels(storeId: string, params: InventoryListParams) {
  return useQuery(inventoryLevelsQueryOptions(storeId, params));
}
